module.exports = __webpack_public_path__ + "img/a16fbd8de66fd8d74a4570cf752b036e.8a3f14ae.jpg";